import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import markAuditCompleteConfirmDialog from '../audits/dialog.markAuditCompleteConfirmDialog';
import selectAgencyDialog from '../audits/dialog.selectAgencyDialog';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';


class dialogService {
  getOptions($event, { settings }) {
    return {
      controller,
      controllerAs: 'settingsDialogVM',
      locals: {
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.settingsDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  markAuditCompleteConfirmDialog,
  selectAgencyDialog,
  ssDialogService,
  userService,
])
  .service('amSettingsDialog', dialogService)
  .name;
